import { Video } from '../../../../types/catalog';

const VideoUrl = ({ url, name }: { url: string; name: string | null }) => (
    <a href={url} className='product-documents-item' target='_blank' rel='noreferrer'>
        <i className='fas fa-download' />
        <div className='product-documents-item__title'>{name || 'Видео'}</div>
    </a>
);
const IframeVideo = ({ url }: Video) => (
    <div className='product-description__video'>
        <iframe title={'Видео'} src={url} frameBorder='0' allowFullScreen />
    </div>
);
const EmbeddedVideo = ({ url, name }: Video) => {
    const isViewable = /(.webm|.mp4)$/i.test(url);
    return isViewable ? (
        <div className='product-description__video'>
            <video controls>
                <source src={url} />
                <VideoUrl url={url} name={name} />
            </video>
        </div>
    ) : (
        <div>
            <VideoUrl url={url} name={name} />
        </div>
    );
};

function VideoDisplay(video: Video) {
    return video.type === 'url' ? <IframeVideo {...video} /> : <EmbeddedVideo {...video} />;
}

export default VideoDisplay;
